import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"

import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { HelmetProvider } from "react-helmet-async"

import { store, persistor } from "./redux/store"
import { Bounce, ToastContainer } from "react-toastify"
import ErrorBoundary from "./components/ErrorBoundary"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <ErrorBoundary>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>

      <ToastContainer
        position="top-right"
        newestOnTop
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        transition={Bounce}
      />
    </HelmetProvider>
  </ErrorBoundary>
)

serviceWorker.unregister()
